/**
 * Formats a date into a localized short date string with numeric month, day and year
 * @param date The date to format
 * @returns Formatted date string
 * @example
 * // For locale 'en-US':
 * shortDateFilter(new Date('2023-12-25T00:00:00Z'))
 * // Returns: "12/25/2023"
 * 
 * // For locale 'pt-BR':
 * shortDateFilter(new Date('2023-12-25T00:00:00Z'))
 * // Returns: "25/12/2023"
* 
 * The timeZone: 'UTC' option is needed because dates are stored in UTC format in the database/API.
 * Without it, the date would be converted to the local timezone before formatting, which could
 * shift the date by a day depending on the time component and the user's timezone.
 * 
 * Note: The input date should be in ISO 8601 format (e.g. '2023-12-25T00:00:00Z') which is the
 * standard format for UTC dates. The 'Z' suffix indicates UTC timezone. When creating Date objects,
 * JavaScript automatically parses ISO strings as UTC, but we still need timeZone: 'UTC' to prevent
 * conversion during formatting.
 */
export default (date: Date) => {
  if (!date) return ''
  const locale = navigator.language || navigator.languages[0] || 'en-US'
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: 'UTC'
  }
  return new Date(date).toLocaleDateString(locale, options)
}
